"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPasswordIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledPasswordIcon = styled_components_1.default.div `
  border-radius: 0 6px 6px 0 !important;
  cursor: pointer;

  &:focus {
    border-color: ${config_1.colors.blurple};
  }
`;
